import React from 'react';
import { NavLink } from 'react-router-dom';
import { FiHome, FiUsers, FiLogOut, FiUpload } from 'react-icons/fi';
import { MdAdd, MdOutlineDomain, MdAssignmentInd } from 'react-icons/md';
import { BsClockHistory, BsEye, BsEyeFill } from 'react-icons/bs';
import { LuLogIn } from 'react-icons/lu';
import { trackLogout } from '../../utils/clickTracking';

const Sidebar = () => {
  const user = JSON.parse(localStorage.getItem('user')) || { name: 'Unknown', role: 'guest' };

  const handleLogout = async () => {
    try {
      if (user?.id) {
        await trackLogout(user.id, user.role);
      }
    } catch (err) {
      console.error('Error tracking logout:', err);
    } finally {
      localStorage.clear();
      window.location.href = '/login';
    }
  };

  const linkClasses = ({ isActive }) =>
    `flex items-center gap-3 px-4 py-2 rounded-lg font-medium transition-all ${
      isActive
        ? 'bg-gradient-to-r from-teal-600 to-teal-500 text-white shadow-md'
        : 'text-gray-600 hover:bg-gray-100 hover:text-teal-600'
    }`;

  return (
    <aside className="w-64 bg-white border-r border-gray-200 shadow-lg flex flex-col min-h-screen relative z-10">
      {/* Gradient Overlay */}
      <div className="absolute inset-0 bg-gradient-to-b from-teal-50 via-transparent to-white opacity-20 pointer-events-none"></div>

      {/* Header */}
      <div className="p-5 border-b border-gray-200 z-10 relative">
        <div className="text-xl font-extrabold tracking-wide text-teal-700">Admin Panel</div>
        <div className="text-sm text-gray-500 mt-1">
          {user.name} <span className="text-xs text-gray-400">({user.role})</span>
        </div>
      </div>

      {/* Navigation */}
      <nav className="flex-1 px-3 py-6 space-y-2 z-10 relative">
        <NavLink to="/superadmin" end className={linkClasses}>
          <FiHome /> Dashboard
        </NavLink>
        <NavLink to="/superadmin/Users" className={linkClasses}>
          <FiUsers /> User Management
        </NavLink>
        <NavLink to="/superadmin/circle-targets" className={linkClasses}>
          <MdOutlineDomain /> Circle Targets
        </NavLink>
        <NavLink to="/superadmin/assign" className={linkClasses}>
          <MdAdd /> Assignments
        </NavLink>
        <NavLink to="/superadmin/manage-assignments" className={linkClasses}>
          <MdAssignmentInd /> Manage Assignments
        </NavLink>
        <NavLink to="/superadmin/bulk-upload" className={linkClasses}>
          <FiUpload /> Bulk Upload
        </NavLink>
        <NavLink to="/superadmin/time" className={linkClasses}>
          <MdAdd /> Time Slots
        </NavLink>
        {/* <NavLink to="/superadmin/views" className={linkClasses}>
          <BsEyeFill/> Views
        </NavLink> */}
        <NavLink to="/superadmin/Logins" className={linkClasses}>
          <LuLogIn /> Logins
        </NavLink>
        {/* <NavLink to="/superadmin/history" className={linkClasses}>
          <BsClockHistory /> Timeline
        </NavLink> */}
      </nav>

      {/* Logout */}
      <div className="p-4 border-t border-gray-200 z-10 relative">
        <button
          onClick={handleLogout}
          className="w-full flex items-center justify-center gap-2 bg-red-500 hover:bg-red-600 text-white py-2 rounded-lg font-medium transition"
        >
          <FiLogOut /> Logout
        </button>
      </div>
    </aside>
  );
};

export default Sidebar;
